import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools, Time } from '../../../services'

import { Headerbar, FormInput, HTMLEditor, OnOff, ConfirmLink, YesNo, ClickToCopy, Loader, EditContainer, ImagesPicker, Select } from '../../Reusable'

import SelectAdCategory from './SelectAdCategory'
import SelectAdPro from './SelectAdPro'
import AdValidator from './AdValidator'

import FadeIn from 'react-fade-in';

const opts = [
  { value: 'jobs', label: "Offres d'emploi" },
  { value: 'mode', label: 'Mode' },
  { value: 'beauty', label: 'Beauté' },
  { value: 'sport', label: 'Bien-être et Sport' },
  { value: 'lifestyle', label: 'Lifestyle' },
  { value: 'tech', label: 'Technologie' },
  { value: 'culture', label: 'Culture' },
  { value: 'concert', label: 'Concert' },
  { value: 'show', label: 'Spectacle' },
]

const { useHistory } = require('react-router-dom')

interface Props {
  tools: any;
}
const DiscountForm: React.FC<Props> = (props) => {
  const { item, saving, save, changed, onChange } = props.tools
  const [errors, setErrors] = React.useState<any>({})
  const user = useSelector(state => state.authReducer.user)
  
  React.useEffect(() => {
    updateErrors(item)
  }, [item])

  const updateErrors = (item: any) => {
    const errors: any = AdValidator.getInfoErrors(item)

    setErrors(errors)
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Informations</h3>
      </div>
      <div className="card-body">
        <div className="item-add-form">

          { item.id &&
            <div style={{marginBottom: 20}}>
              Lien du bon plan: <ClickToCopy title={item.share_link} toCopy={item.share_link} />
            </div>
          }
          
          <SelectAdCategory item={item} onChange={(cats) => onChange('categories', cats)} />

          { user.admin &&
            <SelectAdPro item={item} onChange={(proId) => onChange('proId', proId)} />
          }
          
          { user.admin &&
            <OnOff
              label="Edition limité"
              checked={item.isLimited || false}
              onChange={(checked: boolean) => onChange('isLimited', checked)}
              />
          }
          
          { user.admin &&
            <OnOff
              label="Nouveauté"
              checked={item.isNew || false}
              onChange={(checked: boolean) => onChange('isNew', checked)}
              />
          }
          
          <FormInput
            type="text"
            placeholder="Nom à afficher"
            value={item.name}
            error={errors.name}
            onChange={(evt: any) => onChange('name', evt.target.value)}
          />

          <FormInput
            type="text"
            placeholder="Présentation de l'offre"
            value={item.offer}
            error={errors.offer}
            onChange={(evt: any) => onChange('offer', evt.target.value)}
            />

          <HTMLEditor
            disabled={saving}
            error={errors.description}
            value={item.description}
            placeholder="Décription détaillée..."
            onChange={(val: string) => onChange('description', val)}
            />

          <FormInput
            type="text"
            placeholder="Lien d'affiliation"
            value={item.link}
            error={errors.link}
            onChange={(evt: any) => onChange('link', evt.target.value)}
            />

          <YesNo
            label="Ouvrir en dehors de l'application"
            value={item.outApp || false}
            onChange={(outApp) => onChange('outApp', outApp)}
            />
        </div>

        <div className="centered">
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={save}
            disabled={saving || !changed || errors.name !== undefined}
            >
            { saving ? 'Chargement...' : 'Enregistrer' }
          </button>
        </div>
      </div>
    </div>
  )
}

export default DiscountForm
